/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    size: {
      description: 'used for full-screen spinners',
      type: 'variant',
      values: [ 'large' ]
    }
  },
  rules: [ { if: { size: 'large' }, tokens: { size: 48, thickness: 4 } } ],
  tokens: { color: '#2b8000', size: 24, thickness: 2 }
}
export default theme
